import React from 'react';
import styled from '@emotion/styled';
import { useContextSelector } from 'use-context-selector';

import { EditorContext } from '../../contexts';
import { COLORS } from '../../styles/colors';

interface EditorPlaceholderProps {
  icon?: React.ReactElement;
  message?: string;
  className?: string;
}

export function EditorPlaceholder({
  icon,
  message,
  className,
}: EditorPlaceholderProps) {
  const editorContext = useContextSelector(EditorContext, (context) => context);
  const isEditor = !!editorContext;
  const isEditMode = editorContext?.getState().displayMode === 'edit';

  if (!isEditor || !isEditMode) {
    return null;
  }

  return (
    <Box className={className}>
      { icon && <Icon>{ icon }</Icon> }
      { message && <span>{ message }</span> }
    </Box>
  );
}

const Box = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 10px;
  font-size: 14px;
  color: ${COLORS.slategray50};
  text-align: center;
  border: 5px solid transparent;
  border-radius: 10px;
  background: ${COLORS.slategray5};
  background-clip: padding-box;
  mix-blend-mode: multiply;
  > * ~ * {
    margin-top: 10px;
  }
`;

const Icon = styled.i`
  width: 18px;
  height: 18px;
  svg {
    width: 100%;
    height: 100%;
  }
`;
